import { globalConstants, homeConstants } from "../../constants";
import { getItemFromStorage } from "../../system/storage";

const { SUCCESS } = globalConstants;
const {
  ALL_HOBBIES,
  ALL_CURRENCIES,
  DEFAULT_CURRENCY,
  ALL_ALLOWED_COUNTRIES,
  ALL_DAY_TO_DAY_ACTIVITY,
  ALL_MUST_HAVE_AMMENITIES,
} = homeConstants;

const initialState = {
  allHobbies: [],
  allCurrencies: [],
  allDayToDayActivity: [],
  allAllowedCountries: [],
  allMustHaveAmmenities: [],
  allCurrenciesConversionRates: [],
  defaultCurrency: getItemFromStorage("defaultCurrency"),
};

export const homeReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_CURRENCIES + SUCCESS:
      return {
        ...state,
        allCurrencies: action.data,
      };
    case ALL_ALLOWED_COUNTRIES + SUCCESS:
      return {
        ...state,
        allAllowedCountries: action.data,
      };
    case ALL_MUST_HAVE_AMMENITIES + SUCCESS:
      return {
        ...state,
        allMustHaveAmmenities: action.data,
      };
    case DEFAULT_CURRENCY:
      return {
        ...state,
        defaultCurrency: action.data,
      };
    case ALL_HOBBIES + SUCCESS:
      return { ...state, allHobbies: action.data };
    case ALL_DAY_TO_DAY_ACTIVITY + SUCCESS:
      return { ...state, allDayToDayActivity: action.data };
    default:
      return state;
  }
};
